import { useState, useEffect, ReactNode } from "react";
import { IntroAnimation } from "./IntroAnimation";

const SESSION_KEY = "outlaws_intro_played";

interface IntroGateProps {
  children: ReactNode;
}

/**
 * Wraps the app and plays the ØUTLAWS intro logo animation once per browser
 * session, regardless of which route the user lands on first (e.g. `/`,
 * `/auth`, `/auth?ref=CODE`, `/shop`, deep links, etc.).
 */
export const IntroGate = ({ children }: IntroGateProps) => {
  const [showIntro, setShowIntro] = useState(() => {
    if (typeof window === "undefined") return false;
    try {
      return sessionStorage.getItem(SESSION_KEY) !== "1";
    } catch {
      return true;
    }
  });

  useEffect(() => {
    if (!showIntro) return;
    try {
      sessionStorage.setItem(SESSION_KEY, "1");
    } catch {
      // ignore — private mode etc.
    }
  }, [showIntro]);

  if (showIntro) {
    return <IntroAnimation onComplete={() => setShowIntro(false)} />;
  }

  return <>{children}</>;
};
